import React from "react";
import { Link, Route } from "react-router-dom";

import { ILeague, ILeagueSchedule, ITeamSchedule } from "@src/types/api";

import NotFound from "@components/NotFound";

import LeaguesLayout from "@Leagues/components/Layout";
import League from "@Leagues/components/League";
import PlayoffBracket from "@Leagues/components/PlayoffBracket";
import Schedule from "@Leagues/components/Schedule";
import LeaguesIndex from "@Leagues/index";
import LeagueLoader from "@Leagues/loaders/leagueLoader";
import LeaguesLoader from "@Leagues/loaders/leaguesLoader";
import PlayoffLoader from "@Leagues/loaders/playoffLoader";
import ScheduleLoader from "@Leagues/loaders/scheduleLoader";
import TeamLoader from "@Leagues/loaders/teamLoader";

import Team from "@/app/src/pages/Leagues/components/Team";

export default (
    <Route
        path="leagues"
        handle={{
            crumb: () => "Leagues",
        }}
        element={<LeaguesLayout />}
    >
        <Route
            index
            element={<LeaguesIndex />}
            loader={LeaguesLoader}
            handle={{
                header: () => "Leagues",
            }}
        />
        <Route
            path=":leagueId"
            loader={LeagueLoader}
            handle={{
                crumb: ({ league }: { league: ILeague }) => (
                    <Link to={`/leagues/${league.id}`}>
                        {league.ageLevel}
                        {league.designation ? " " + league.designation : ""}
                        {league.direction ? " " + league.direction : ""}
                    </Link>
                ),
            }}
        >
            <Route
                index
                element={<League />}
                loader={LeagueLoader}
                handle={{
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="schedule"
                element={<Schedule scheduleType="league" />}
                loader={ScheduleLoader}
                handle={{
                    crumb: ({ schedule }: { schedule: ILeagueSchedule }) => (
                        <Link to={`/leagues/${schedule.league}/schedule`}>
                            Schedule
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="playoffs"
                element={<PlayoffBracket />}
                loader={PlayoffLoader}
                handle={{
                    crumb: (league: ILeague) => (
                        <Link to={`/leagues/${league.id}/playoffs`}>
                            Playoff Bracket
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="teams/:teamId"
                element={<Team />}
                loader={TeamLoader}
                handle={{
                    crumb: ({ schedule }: { schedule: ITeamSchedule }) => (
                        <Link
                            to={`/leagues/${schedule.league}/teams/${schedule.teamId}`}
                        >
                            {schedule.teamName}
                        </Link>
                    ),
                    header: ({ teamName }: { teamName: string }) =>
                        `${teamName} Home`,
                }}
            >
                <Route
                    path="schedule"
                    element={<Schedule scheduleType="team" />}
                    loader={TeamLoader}
                    handle={{
                        crumb: ({ schedule }: { schedule: ITeamSchedule }) => (
                            <Link
                                to={`/leagues/${schedule.league}/teams/${schedule.teamId}/schedule`}
                            >
                                Schedule
                            </Link>
                        ),
                        header: ({ teamName }: { teamName: string }) =>
                            `${teamName} Schedule`,
                    }}
                />
            </Route>
            <Route
                path="*"
                element={<NotFound parent="leagues" />}
                handle={{ header: () => "League Page Not Found" }}
            />
        </Route>
    </Route>
);
